import React from "react";
import PartnershipsHero from "./PartnershipsHero";
import PartnerBenefits from "./PartnerBenefits";
import IntegrationFramework from "./IntegrationFramework";
import PartnerNetwork from "./PartnerNetwork";
import Contact from "../common/Contact";
import Footer from "../common/Footer";

const Partnerships = () => {
  return (
    <>
      <PartnershipsHero />
      <PartnerBenefits />
      <IntegrationFramework />
      <PartnerNetwork />
      <Contact />
      <Footer />
    </>
  );
};

export default Partnerships;
